import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import { observer } from 'mobx-react-lite';
import CensusReviewPageStore, {
  CensusReviewPageStoreContext,
  useCensusReviewPageStore,
} from 'store/pages/enrollment/manage-add-employees/census-review/pageStore';
import PageHeader from 'components/common/census/census-review/PageHeader';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useCensusReviewPageStore();
  return (
    <>
      <PageHeader pageStore={pageStore} />
      <CensusStatistics pageStore={pageStore} />
    </>
  );
});

const CensusReviewPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new CensusReviewPageStore({ groupId, enrollmentPeriodId: periodId }), []);

  return (
    <ProposalStatusLayout>
      <CensusReviewPageStoreContext.Provider value={pageStore}>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </CensusReviewPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
};

export default CensusReviewPage;
